// styles.css is linked directly from index.html (build.mjs copies it to
// dist/) rather than imported here, to avoid esbuild emitting a redundant
// second CSS bundle.
import { $ } from "./dom.js";
import { STATE } from "./state.js";
import { getToken, authApi, clearToken } from "./api-client.js";
import { setupLoginUI, showLoginView } from "./auth-view.js";
import { setupAppNav, refreshSidebar, renderView, parseUrl, syncUrl } from "./router.js";
import { closeModal } from "./dom.js";

let navReady = false;
// Captured once at page load, before the login check can short-circuit -
// replayed by enterApp() so a deep link survives a login prompt instead of
// always resetting to the studies list (source's original enterApp() had no
// concept of a URL at all - this is a genuine addition, not a port).
let pendingDeepLink: string | null = null;

// Ported from enterApp() (source line 3206): switch from the login page to
// the main app shell. Now restores whatever page the URL (or a stashed
// pre-login deep link) points to, rather than always landing on the studies
// list - see docs on the routing addition.
export function enterApp(): void {
  if (!STATE.user) return;
  $("#loginPage")!.classList.add("hidden");
  $("#app")!.classList.remove("hidden");
  $("#hdrUserName")!.textContent = STATE.user.fullName || STATE.user.username;
  $("#hdrUserRole")!.textContent = STATE.user.role;

  if (!navReady) {
    setupAppNav();
    navReady = true;
  }
  const target = pendingDeepLink ?? location.pathname + location.search;
  pendingDeepLink = null;
  Object.assign(STATE, parseUrl(target));
  syncUrl(true); // canonicalize the address bar (e.g. unrecognized paths -> /studies)
  void refreshSidebar();
  void renderView();
}

async function bootstrap(): Promise<void> {
  pendingDeepLink = location.pathname + location.search; // capture before any early return below
  setupLoginUI();
  $("#modalClose")!.addEventListener("click", closeModal);
  $("#modalOverlay")!.addEventListener("click", (e) => {
    if (e.target === $("#modalOverlay")) closeModal();
  });

  const token = getToken();
  if (!token) {
    showLoginView();
    return;
  }
  try {
    const user = await authApi.me();
    STATE.user = {
      id: user.id,
      username: user.username,
      role: user.role,
      sites: user.sites,
      fullName: user.fullName,
      mustChangePassword: user.mustChangePassword,
    };
    if (user.mustChangePassword) {
      showLoginView();
      return;
    }
    enterApp();
  } catch {
    clearToken();
    showLoginView();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  void bootstrap();
});
